import { About } from "./components/About";
import { Alert } from "./components/Alert";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
function App() {
  const [mode, setmode] = useState("light");
  const [alert, setalert] = useState(null);
  const showAlert = (message, type) => {
    setalert({
      message: message,
      type: type
    })
    setTimeout(() => {
      setalert(null)
    }, 2000);
  }
  const togglemode = () => {
    if (mode === "dark") {
      setmode("light")
      document.body.style.backgroundColor = "white"
      showAlert("Light mode is Enabled", "success");
    }
    else {
      setmode("dark")
      document.body.style.backgroundColor = "#01030d";
      showAlert("Dark mode is Enabled", "success");
    }
  }
  return (
    <>
      <Router>
        <div>
          <Navbar title="TextUtils" mode={mode} togglemode={togglemode} />
          <Alert alert={alert} />
          <Routes>

            <Route path="/" element={<TextForm showAlert={showAlert} heading="Enter the text to analyze" mode={mode} />

            } />
            <Route path="/about" element={<About mode={mode}/>} />
          </Routes>
        </div>
      </Router>

    </>
  );
}

export default App; 
